import React, { useEffect } from 'react';
import { Cloud, Database, Shield } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const AzureSQL = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('azure-sql');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Migration',
      icon: Cloud,
      description: 'Azure SQL migration strategies, tools, and best practices for moving from on-premises to cloud.',
      scripts: getContentByCategory('Azure SQL', 'Migration')
    },
    {
      name: 'Performance',
      icon: Database,
      description: 'Azure SQL performance optimization, monitoring, and tuning techniques for cloud environments.',
      scripts: getContentByCategory('Azure SQL', 'Performance')
    },
    {
      name: 'Security',
      icon: Shield,
      description: 'Azure SQL security features, authentication methods, and compliance configurations.',
      scripts: getContentByCategory('Azure SQL', 'Security')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Azure SQL</h1>
        <p className="page-description">
          Comprehensive Azure SQL resources covering migration, performance optimization, and security 
          best practices for cloud-based SQL Server environments.
        </p>
      </div>

      <CategoryTabs 
        category="Azure SQL"
        scripts={getContentByCategory('Azure SQL')}
        articles={getContentByCategory('Azure SQL', null, 'articles')}
        faqs={getContentByCategory('Azure SQL', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default AzureSQL;